import React, { Component } from "react";
import { checkTranslation, imageAddress, translate } from "../utils/useful";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Modal from "./Modal";
import * as actions from "../stores/actionsList";
// import { Router } from "react-router-dom";
import StagesManager from "./StagesManager";
import MainTower from "./tower/MainTower";
import MyHubs from "./tower/MyHubs";
import MyUpdates from "./tower/MyUpdates";
import MyPortals from "./tower/MyPortals";
import MyDashboard from "./tower/MyDashboard";
import CallTower from "../windows/CallTower";
import AudioPlayerTower from "../windows/AudioPlayerTower";
import Search from "../windows/Search";
import MyRequests from "./tower/MyRequests";


class Tower extends Component {

    state = {
        open: false,
        condition: ''
    }

    toggle = (open) => {
        this.setState({ open: open == null ? !this.state.open : open })
    }

    LogoutModal = () => {
        this.logoutModal.showModal()
    }
    logout = () => {
        this.props.changeWindow('authentication', { path: ['authentication'] })
        setTimeout(() => {
            this.props.actions.logoutUser()


        }, 100);
        setTimeout(() => {

            this.props.addNewWindow("authentication", {}, "center")
            this.logoutModal.hideModal()
        }, 120);
    }

    changeStage = (stage) => {
        this.stagesManager.changeStage(stage)
    }

    render() {
        return (
            <>

                <div className={"tower  " + (this.props.mobile ? ' mobile ' : '') + (this.state.open ? 'open' : '')} style={this.props.language=='en'?{ height: this.props.mobile ? window.innerHeight * 0.8 : '',left:20 }:{height: this.props.mobile ? window.innerHeight * 0.8 : '',right:20}}>
                    <div className="tower-header px-3 py-2 back-blur ">
                        <div className="flexcc">
                            <div className="touch-indicator cursor-pointer mb-1" style={{}} onClick={() => this.toggle()}>
                            </div>
                        </div>
                        <div className="py-1 flexc" style={{ cursor: 'pointer', borderRadius: 0 }} onClick={() => { this.state.open && this.props.addNewWindow("hub", { path: [this.props.user?.info?.username], type: 'hub' }, "center"); this.toggle() }} >
                            <div className="flexc" >
                                <div className={"flexcc tower-button "} style={{ position: 'relative', transform: this.props.mobile ? ` translateY(-90px) scale(0.8) ` : '' }} onClick={() => this.toggle(true)}>
                                    <img className="br-50" style={{ width: '45px', height: '45px', objectFit: 'cover', border: '2px solid #ffffff90', boxShadow: '0px 0px 30px #10101060' }} src={imageAddress(this.props.user?.info?.image, 'profile', 'thumb')} />
                                    {this.state.condition == 'download' &&
                                        <div className="br-20 p-1 flexcc flex-column" style={{ overflow: 'hidden', background: 'linear-gradient(to right, #7F188F, #7826FF)', width: '25px', height: '25px', position: 'absolute', bottom: '-6px', left: '38px' }}>
                                            <img className="invert" src="/assets/icons/tower/arrowdown.svg" width={10} />
                                            <img className="invert" src="/assets/icons/tower/arrowdownline.svg" width={10} />
                                        </div>
                                    }
                                    {this.state.condition == 'upload' &&
                                        <div className="br-20 p-1 flexcc flex-column" style={{ overflow: 'hidden', background: 'linear-gradient(to right, #7F188F, #7826FF)', width: '25px', height: '25px', position: 'absolute', bottom: '-6px', left: '38px' }}>
                                            <img className="invert" src="/assets/icons/tower/arrowdown.svg" width={10} style={{ transform: 'rotate(180deg)' }} />
                                            <img className="invert" src="/assets/icons/tower/arrowdownline.svg" width={10} />
                                        </div>
                                    }
                                    {(!this.state.open && this.state.condition == 'call') &&
                                        <div className="br-20 flexcc flex-column" style={{ overflow: 'hidden', backgroundColor: 'rgb(43, 165, 46)', width: '25px', height: '25px', position: 'absolute', bottom: '-6px', left: '30px' }}>
                                            <img className="" src="/assets/icons/tower/call.svg" style={{ scale: '0.8' }} />
                                        </div>
                                    }
                                </div>
                                <div className="mld-4" >
                                    <p>{this.props.user?.info?.fullname}</p>
                                    <div className="flexc">
                                        <p style={{ fontSize: '12px' }}>{translate('View Profile')}</p>
                                        <img src="/assets/icons/angle-right.svg" className='rtl-button' height={14} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="h-100 "> */}
                    {/* <CallTower />
                        <AudioPlayerTower language={this.props.language} /> */}

                    <div className="tower-body h-100 bg-white scroll-no-scrollbar" style={{}}>
                        <StagesManager ref={el => this.stagesManager = el} height='100%' fast="true" >
                            <MainTower stage={0} stageName="Home" changeStage={this.changeStage} language={this.props.language} addNewWindow={this.props.addNewWindow} toggle={this.toggle} LogoutModal={this.LogoutModal} />
                            <MyHubs stage={1} stageName="Hubs" changeStage={this.changeStage} language={this.props.language} addNewWindow={this.props.addNewWindow} toggle={this.toggle} />
                            <MyPortals stage={1} stageName="Portals" changeStage={this.changeStage} language={this.props.language} addNewWindow={this.props.addNewWindow} toggle={this.toggle} />
                            <MyDashboard stage={1} stageName="Dashboard" changeStage={this.changeStage} language={this.props.language} />
                            <MyUpdates stage={2} stageName="Update" changeStage={this.changeStage} language={this.props.language} />
                            <MyRequests stage={3} stageName="Request" changeStage={this.changeStage} language={this.props.language} addNewWindow={this.props.addNewWindow} />
                        </StagesManager>
                    </div>
                    {/* </div> */}
                    {/* </div> */}
                </div >
                <Modal maxWidth={350} ref={el => this.logoutModal = el}>
                    <div className="text-center" style={{ backgroundColor: '#fff', borderRadius: 20, padding: '30px' }}>
                        <p className="text-big text-bold">{translate(`Log out`)}</p>
                        <p className="text-small">{translate(`Are you sure you want to log out?`)}</p>

                        <div className="flexcc mt-5">
                            <button onClick={() => this.logout()} className="px-4 py-2 white text-bold text-small mrd-2" style={{ backgroundColor: '#FF3B30', borderRadius: 30 }}>{translate(`Log out`)}</button>
                            <button onClick={() => this.logoutModal.hideModal()} className="px-4 py-2 text-small" style={{ backgroundColor: '#E5E5EA', borderRadius: 30 }}>{translate(`Cancel`)}</button>
                        </div>
                    </div>
                </Modal>

            </>
        )
    }
}

const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Tower);
